/**
 * Empêche d'augmenter la quantité du maillot offert (cadeau à 0,00€) au-delà
 * de 1, quelle que soit la façon de l'incrémenter : clic sur "+", saisie
 * manuelle, ou après un changement de version (Domicile/Extérieur) qui
 * remplace la ligne dans le panier.
 *
 * Pourquoi ce fichier existe : le composant natif du thème
 * (CartQuantitySelectorComponent, voir component-cart-quantity-selector.js)
 * recalcule lui-même l'état "disabled" des boutons uniquement à partir des
 * règles de quantité Shopify (min/max de la variante) - il ignore
 * complètement l'attribut "disabled" posé côté Liquid, et le réapplique à
 * chaque mise à jour du panier (morph de section).
 *
 * Double protection :
 * 1. On intercepte les clics/saisies en phase de capture, avant que le
 *    composant du thème ne les traite.
 * 2. Un MutationObserver réapplique en permanence "disabled"/"readonly" sur
 *    les lignes cadeau, à chaque changement du DOM (ajout, morph, etc.).
 */
(function () {
  if (window.__cartGiftGuardInitialized) return;
  window.__cartGiftGuardInitialized = true;

  var GIFT_ROW_SELECTOR = '[data-gift="true"]';

  /**
   * @param {Element | null} el
   * @returns {boolean}
   */
  function isInGiftRow(el) {
    return !!(el && el.closest(GIFT_ROW_SELECTOR));
  }

  /**
   * Force la quantité à 1 et verrouille les contrôles pour toutes les
   * lignes cadeau actuellement présentes dans le DOM.
   */
  function lockGiftRows() {
    document.querySelectorAll(GIFT_ROW_SELECTOR).forEach(function (row) {
      var minusButton = row.querySelector('.quantity-minus');
      var plusButton = row.querySelector('.quantity-plus');
      var input = row.querySelector('input[type="number"]');

      if (plusButton instanceof HTMLButtonElement) {
        plusButton.disabled = true;
      }
      if (input instanceof HTMLInputElement) {
        input.readOnly = true;
        if (input.value !== '1') {
          input.value = '1';
        }
      }
      // Le bouton "-" reste actif : il permet de retirer le cadeau
      // complètement (ramène la quantité à 0 = suppression de la ligne).
      if (minusButton instanceof HTMLButtonElement) {
        minusButton.disabled = false;
      }
    });
  }

  // --- Protection 1 : blocage au clic / à la saisie, avant le composant du thème ---

  document.addEventListener(
    'click',
    function (event) {
      var target = /** @type {HTMLElement} */ (event.target);
      var plusButton = target.closest('.quantity-plus');
      if (plusButton && isInGiftRow(plusButton)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    { capture: true }
  );

  document.addEventListener(
    'blur',
    function (event) {
      var input = /** @type {HTMLInputElement} */ (event.target);
      if (
        input instanceof HTMLInputElement &&
        input.matches('input[type="number"]') &&
        isInGiftRow(input) &&
        input.value !== '1'
      ) {
        input.value = '1';
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    { capture: true }
  );

  document.addEventListener(
    'keydown',
    function (event) {
      var input = /** @type {HTMLInputElement} */ (event.target);
      if (
        event.key === 'Enter' &&
        input instanceof HTMLInputElement &&
        input.matches('input[type="number"]') &&
        isInGiftRow(input) &&
        input.value !== '1'
      ) {
        input.value = '1';
      }
    },
    { capture: true }
  );

  // --- Protection 2 : surveillance permanente du panier ---
  // Réapplique le verrou à chaque fois que le panier change (ajout,
  // suppression, changement de version du cadeau, morph de section...).

  var observer = new MutationObserver(function () {
    lockGiftRows();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-gift', 'value'],
  });

  // Verrouillage initial au chargement de la page.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lockGiftRows);
  } else {
    lockGiftRows();
  }
})();